import {
  CognitoUserAttribute
} from "amazon-cognito-identity-js";
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import FilterSelector from '../../components/FilterSelector';
import { supportedRoles, supportedIndustries } from '../../helpers/constants'
import SelectObject from '../WorkflowComponents/Inputs/SelectObject'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { postJson } from "../../helpers/RequestsHelper";
import { timezones } from "../../helpers/constants";
const moment = require('moment-timezone');

//This is a class instead of the functional component, to use the lifecycle for updating the user
class ProfilePage extends Component {

  state = {
    initialEmail: "",
    initialPhone: "",
    email: "",
    phone: "",
    givenName: "",
    familyName: ""
  }

  constructor(props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.redirectToPage = this.redirectToPage.bind(this)
    this.phoneRef = React.createRef();
    //this.onChangePasswordClick = this.onChangePasswordClick.bind(this)
  }

  componentDidMount() {

    const cognitoUser = window.userPool.getCurrentUser()
    const self = this
    if (cognitoUser != null) {
      cognitoUser.getSession(async (err, session) => {
        if (err) {
          //TODO: [Error handling] alert(err.message || JSON.stringify(err));
          return;
        }
        // NOTE: getSession must be called to authenticate user before calling getUserAttributes
        cognitoUser.getUserAttributes(function (err, result) {
          if (result) {
            let newState = {}
            for (let i = 0; i < result.length; i++) {

              const value = result[i].getValue()

              switch (result[i].getName()) {
                case "email": newState.email = value; break;
                case "phone_number": newState.phone = value; break;
                case "phone_number_verified": newState.phoneVerified = (value === "true"); break;
                case "given_name": newState.givenName = value; break;
                case "family_name": newState.familyName = value; break;
                case "custom:role": newState.role = value; break;
                case "custom:industry": newState.industry = value; break;
                case "zoneinfo": newState.zoneinfo = timezones.find(a => a.id === value); break;
                case "custom:marketing_email": newState.marketingEmails = (value == "true"); break;
                default: break;
              }
            }
            newState.initialEmail = newState.email
            newState.initialPhone = newState.phone
            if (!newState.zoneinfo) {
              newState.zoneinfo = timezones.find(a => a.id === moment.tz.guess())
            }
            self.setState(newState)
          }
        })
        const welcome = this.props.location.search ? this.props.location.search.includes("welcome") : false;
        if (welcome) {
          await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/updateProfile", { newUser: true });

          const redirect = sessionStorage.getItem("redirect")
          if (redirect) {
            sessionStorage.removeItem("redirect")
            this.props.history.push(decodeURIComponent(redirect))
          }

          //TODO: Find better way
          if (window.loadRewards) {
            await window.loadRewards()
          }
        }
      })
    }

    //const input = document.querySelector("#phone");
    // intlTelInput(this.phoneRef.current, {
    //   // any initialisation options go here
    // });
  }

  onSubmit(e) {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked = false) {
      return
    }
    const attributeList = [
      new CognitoUserAttribute({
        Name: 'given_name',
        Value: this.state.givenName.trim()
      }),
      new CognitoUserAttribute({
        Name: 'family_name',
        Value: this.state.familyName.trim()
      }),
      new CognitoUserAttribute({
        Name: 'custom:role',
        Value: this.state.role
      }),
      new CognitoUserAttribute({
        Name: 'custom:industry',
        Value: this.state.industry
      }),
      new CognitoUserAttribute({
        Name: 'zoneinfo',
        Value: this.state.zoneinfo.id
      }),
      new CognitoUserAttribute({
        Name: 'custom:marketing_email',
        Value: this.state.marketingEmails ? "true" : "false"
      }),
    ];

    const emailChanged = (this.state.initialEmail !== this.state.email)

    if (emailChanged) {
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'email',
          Value: this.state.email.trim(),
        }))
    }

    let phoneChanged = false
    let phone = ""
    if (this.state.phone !== undefined) {
      phone = this.state.phone.trim()
      if (this.state.initialPhone === undefined && phone === "") {
        phoneChanged = false
      } else {
        phoneChanged = this.state.initialPhone !== phone
      }

      if (phoneChanged) {
        if (phone !== "") {
          phone = "+" + phone
        }
        attributeList.push(
          new CognitoUserAttribute({
            Name: 'phone_number',
            Value: phone,
          }))
      }
    }

    let self = this
    const cognitoUser = window.userPool.getCurrentUser()
    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          button.clicked = false
          self.setState({ error: err.message })
          return;
        }
        cognitoUser.updateAttributes(attributeList, function (err, result) {
          if (err) {
            button.clicked = false
            self.setState({ error: err.message })
            return;
          }
          cognitoUser.refreshSession(session.getRefreshToken(), (err, session) => {
            self.redirectToPage(emailChanged, phoneChanged, phone)
          });
        });
      });
    }
  }

  onSignOut = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true

    sessionStorage.removeItem("workflowState")

    var cognitoUser = window.userPool.getCurrentUser()

    cognitoUser.signOut()
    window.location = "/user/login"
  }

  redirectToPage = async (emailChanged, phoneChanged, phone) => {
    await postJson(process.env.REACT_APP_SERVER_BASE_URL + "/updateProfile", {});

    if (emailChanged) {
      //TODO: Should we use history?
      //history.push("/user/confirmation")
      window.location = "/user/verifyemail";
    } else if (phoneChanged && phone !== "") {
      //TODO: Should we use history?
      //history.push("/user/confirmation")
      window.location = "/user/verifyphone";
    } else {
      //TODO: Should we use history?
      window.location = "/workflows";
    }
  }

  render() {

    const { t } = this.props;

    document.title = t("titleappname") + t("title_profile")

    const welcome = this.props.location.search ? this.props.location.search.includes("welcome") : false;

    return this.props.isLegacy ?
      <div>
        <div className="login100-form validate-form">
          <h3>{t("title_profile")}</h3>
          {welcome ? <>
            <br />
            <h5>{t("lbl_profile_welcome")}</h5>
            <br />
          </> : ""}
          <div className="validate-input w-400">
            <span className="label-input100">{t("lbl_email")}</span>
            <input className="form-control"
              type="email"
              name="email"
              autoComplete="email"
              id="email"
              placeholder={t("tip_email")}
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.currentTarget.value })}
              required={true} />
            <span className="focus-input100" data-symbol="&#xf1fa;"></span>
          </div>
          <form>
            <div className="validate-input w-400">
              <span className="label-input100">{t("lbl_phone")}</span><br />
              <PhoneInput
                inputStyle={{ width: "400px" }}
                inputProps={{ id: 'phone', name: 'phone', autoComplete: "tel" }}
                country={'us'}
                value={this.state.phone}
                placeholder={t("tip_phone")}
                onChange={phone => this.setState({ phone })}
              />
            </div>
          </form>
          {this.state.phone && this.state.phone !== "" && (this.state.initialPhone === this.state.phone) && !this.state.phoneVerified ?
            <input type="button" className="submit-btn" value={t("btn_validate_phone")} onClick={() => window.location = "/user/verifyphone"} />
            :
            ""}

          <div className="d-flex">
            <div className="validate-input">
              <span className="label-input100">{t("lbl_name")}</span><br />
              <input className="form-control w-190"
                type="text"
                name="given-name"
                autoComplete="given-name"
                id="given-name"
                placeholder={t("tip_given_name")}
                value={this.state.givenName}
                onChange={(e) => this.setState({ givenName: e.currentTarget.value })}
                onBlur={(e) => this.setState({ givenName: e.currentTarget.value.trim() })}
                required={true} />
              <span className="focus-input100" data-symbol="&#xf007;"></span>
            </div>
            <div style={{ width: "20px" }}>&nbsp;</div>
            <div className="validate-input">
              <br />
              <input className="form-control w-190"
                type="text"
                name="family-name"
                autoComplete="family-name"
                id="family-name"
                placeholder={t("tip_family_name")}
                value={this.state.familyName}
                onChange={(e) => this.setState({ familyName: e.currentTarget.value })}
                onBlur={(e) => this.setState({ familyName: e.currentTarget.value.trim() })}
                required={true} />
              <span className="focus-input100" data-symbol="&#xf0c0;"></span>
            </div>
          </div>
          <div className="validate-input w-400">
            <span className="label-input100">{t("lblrole")}</span>
            <FilterSelector id="role" items={supportedRoles} onSelect={(id) => this.setState({ role: id })} selected={this.state.role} singleSelect={true} />
          </div>

          <div className="validate-input w-400">
            <span className="label-input100">{t("lblindustry")}</span>
            <FilterSelector id="industry" items={supportedIndustries} onSelect={(id) => this.setState({ industry: id })} selected={this.state.industry} singleSelect={true} />
          </div>

          <div className="validate-input w-400">
            <span className="label-input100">{t("lbl_timezone")}</span>
            <SelectObject
              id="timezone"
              items={timezones}
              fieldName="name"
              onSelect={(zoneinfo) => this.setState({ zoneinfo })}
              selected={this.state.zoneinfo} />
          </div>

          <br />
          <div className="custom-control custom-switch">
            <input type="checkbox" className="custom-control-input" id="marketing_email" onChange={(e) => this.setState({ marketingEmails: e.target.checked })} checked={this.state.marketingEmails} />
            <label className="custom-control-label" htmlFor="marketing_email">{t("lbl_marketing_email")}</label>
          </div>
          <br />
          <a href="#" onClick={() => this.props.history.push("/user/changepassword")}>{t("btn_change_password")}</a>
          <br />

          {this.state.initialEmail !== this.state.email ? <small id="warning" className="text-warning">{t("warning_email_change")}<br /></small> : ""}
          {this.state.phone && this.state.initialPhone !== this.state.phone ? <small id="warning" className="text-warning">{t("warning_phone_change")}<br /></small> : ""}
          {this.state.error ? <small id="errorMessage" className="text-danger">{this.state.error}<br /></small> : ""}
          <br />
          <div>
            <button className="submit-btn" onClick={this.onSubmit}>{t("btn_profile_update")}</button>
          </div>
          <div style={{ height: 50 }} />
        </div>

        <div className="wrap-login100">
          <form className="login100-form validate-form" onSubmit={this.onSignOut}>
            <h3>{t("title_signout")}</h3>

            <div>
              <button className="submit-btn-2">{t("btn_signout")}</button>
            </div>
          </form>
        </div>
      </div>
      :
      <div>
        <div className="login100-form validate-form">
          <h3>{t("title_profile")}</h3>
          {welcome ? <>
            <br />
            <h5>{t("lbl_profile_welcome")}</h5>
            <br />
          </> : ""}
          <div className="validate-input" style={{ width: this.props.windowWidth > 993 ? "400px" : this.props.isLegacy ? "400px" : "100%" }}>
            <span className="label-input100">{t("lbl_email")}</span>
            <input className="form-control"
              type="email"
              name="email"
              autoComplete="email"
              id="email"
              placeholder={t("tip_email")}
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.currentTarget.value })}
              required={true} />
            <span className="focus-input100" data-symbol="&#xf1fa;"></span>
          </div>
          <form>
            <div className="validate-input" style={{ width: this.props.windowWidth > 993 ? "400px" : this.props.isLegacy ? "400px" : "100%" }}>
              <span className="label-input100">{t("lbl_phone")}</span><br />
              <PhoneInput
                inputStyle={{ width: this.props.windowWidth > 993 ? "400px" : this.props.isLegacy ? "400px" : "100%" }}
                inputProps={{ id: 'phone', name: 'phone', autoComplete: "tel" }}
                country={'us'}
                value={this.state.phone}
                placeholder={t("tip_phone")}
                onChange={phone => this.setState({ phone })}
              />
            </div>
          </form>
          {this.state.phone && this.state.phone !== "" && (this.state.initialPhone === this.state.phone) && !this.state.phoneVerified ?
            <input type="button" className="submit-btn" value={t("btn_validate_phone")} onClick={() => window.location = "/user/verifyphone"} />
            :
            ""}

          <div className="d-flex">
            <div className="validate-input" style={{ flex: this.props.windowWidth > 993 ? "initial" : "1" }}>
              <span className="label-input100">{t("lbl_name")}</span><br />
              <input className="form-control"
                style={{ width: this.props.windowWidth > 993 ? "190px" : "100%" }}
                type="text"
                name="given-name"
                autoComplete="given-name"
                id="given-name"
                placeholder={t("tip_given_name")}
                value={this.state.givenName}
                onChange={(e) => this.setState({ givenName: e.currentTarget.value })}
                onBlur={(e) => this.setState({ givenName: e.currentTarget.value.trim() })}
                required={true} />
              <span className="focus-input100" data-symbol="&#xf007;"></span>
            </div>
            <div style={{ width: "20px" }}>&nbsp;</div>
            <div className="validate-input" style={{ flex: this.props.windowWidth > 993 ? "initial" : "1" }}>
              <br />
              <input className="form-control"
                style={{ width: this.props.windowWidth > 993 ? "190px" : "100%" }}
                type="text"
                name="family-name"
                autoComplete="family-name"
                id="family-name"
                placeholder={t("tip_family_name")}
                value={this.state.familyName}
                onChange={(e) => this.setState({ familyName: e.currentTarget.value })}
                onBlur={(e) => this.setState({ familyName: e.currentTarget.value.trim() })}
                required={true} />
              <span className="focus-input100" data-symbol="&#xf0c0;"></span>
            </div>
          </div>
          <div className="validate-input" style={{ width: this.props.windowWidth > 993 ? "400px" : this.props.isLegacy ? "400px" : "100%" }}>
            <span className="label-input100">{t("lblrole")}</span>
            <FilterSelector id="role" items={supportedRoles} onSelect={(id) => this.setState({ role: id })} selected={this.state.role} singleSelect={true} />
          </div>

          <div className="validate-input" style={{ width: this.props.windowWidth > 993 ? "400px" : this.props.isLegacy ? "400px" : "100%" }}>
            <span className="label-input100">{t("lblindustry")}</span>
            <FilterSelector id="industry" items={supportedIndustries} onSelect={(id) => this.setState({ industry: id })} selected={this.state.industry} singleSelect={true} />
          </div>

          <div className="validate-input" style={{ width: this.props.windowWidth > 993 ? "400px" : this.props.isLegacy ? "400px" : "100%" }}>
            <span className="label-input100">{t("lbl_timezone")}</span>
            <SelectObject
              id="timezone"
              items={timezones}
              fieldName="name"
              onSelect={(zoneinfo) => this.setState({ zoneinfo })}
              selected={this.state.zoneinfo} />
          </div>

          <br />
          <div className="custom-control custom-switch">
            <input type="checkbox" className="custom-control-input" id="marketing_email" onChange={(e) => this.setState({ marketingEmails: e.target.checked })} checked={this.state.marketingEmails} />
            <label className="custom-control-label" htmlFor="marketing_email">{t("lbl_marketing_email")}</label>
          </div>
          <br />
          <a href="#" onClick={() => this.props.history.push("/user/changepassword")}>{t("btn_change_password")}</a>
          <br />

          {this.state.initialEmail !== this.state.email ? <small id="warning" className="text-warning">{t("warning_email_change")}<br /></small> : ""}
          {this.state.phone && this.state.initialPhone !== this.state.phone ? <small id="warning" className="text-warning">{t("warning_phone_change")}<br /></small> : ""}
          {this.state.error ? <small id="errorMessage" className="text-danger">{this.state.error}<br /></small> : ""}
          <br />
          <div>
            <button className="submit-btn" onClick={this.onSubmit}>{t("btn_profile_update")}</button>
          </div>
          <div style={{ height: 50 }} />
        </div>

        <div className="wrap-login100" style={{ padding: 0 }}>
          <form className="login100-form validate-form" onSubmit={this.onSignOut}>
            <h3>{t("title_signout")}</h3>

            <div>
              <button className="submit-btn-2">{t("btn_signout")}</button>
            </div>
          </form>
        </div>
      </div>
  }
}

export default withRouter(withTranslation()(ProfilePage), ProfilePage);